import React, { useEffect, useState } from "react";
import AddButton from "../../../components/admin/usable/AddButton";
import CancelButton from "../../../components/admin/usable/CancelButton";
import EditButton from "../../../components/admin/usable/actions/EditButton";
import DeleteButton from "../../../components/admin/usable/actions/DeleteButton";
import {
  addBlogCategory,
  DeleteBlogCategory,
  UpdateBlogCategory,
  viewBlogCategory,
} from "../../../api/admin/blogApi";
import toast from "react-hot-toast";
import TableLoader from "../../../components/admin/usable/TableLoader";

const BlogCategories = () => {
  const [CategoryData, setCategoryData] = useState([]);
  const [FormData, setFormData] = useState({
    id: null,
    category_name: "",
    parent_Id: null,
    parent_category: "",
    status: 1,
    createdAt: new Date().toISOString(),
  });

  const handleChange = (e) => {
    const { id, value } = e.target;

    if (id === "parent_Id") {
      const selected = CategoryData.find((item) => item.id == value);

      setFormData((prev) => ({
        ...prev,
        parent_Id: value,
        parent_category: selected ? selected.category_name : "",
      }));
      return;
    }

    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (FormData.id) {
      UpdateBlogCategory(FormData, setFormData, setCategoryData);
    } else {
      if (FormData.category_name !== "") {
        addBlogCategory(FormData, setFormData, setCategoryData);
      } else {
        toast.error("Enter Category Name");
      }
    }
  };

  useEffect(() => {
    viewBlogCategory(setCategoryData);
  }, []);
  const handleEdit = (item) => {
    setFormData({
      id: item.id,
      category_name: item.category_name,
      parent_Id: item.parent_Id,
      status: item.status,
      createdAt: item.createdAt,
    });
  };
  const handleCancel = () => {
    setFormData({
      id: null,
      category_name: "",
      parent_Id: null,
      parent_category: "",
      status: 1,
      createdAt: new Date().toISOString(),
    });
  };
  const handleDelete = (item) => {
    if (item.id !== "") {
      const id = item.id;
      DeleteBlogCategory(id, setCategoryData);
    } else {
      toast.error("Please refresh!");
    }
  };
  return (
    <div className="p-5 bg-white rounded-lg  space-y-5">
      <div>
        <p className="font-bold">Categories</p>
      </div>
      <div className="flex gap-5">
        <div className="w-[400px] h-[270px] border drop-shadow p-3 bg-white rounded-lg">
          <div>
            <p className="text-sm font-bold pb-3">
              {FormData.id ? "Edit Categories" : "Add Categories"}
            </p>
          </div>

          <div className="space-y-6">
            <div>
              <label className="text-xs">Category Name</label>
              <input
                type="text"
                className="w-full px-4 py-2 rounded-lg border focus:outline-none text-xs"
                placeholder="Category Name"
                id="category_name"
                value={FormData.category_name}
                onChange={handleChange}
              />
            </div>

            <div>
              <label className="text-xs">Parent</label>
              <select
                className="w-full px-4 py-2 rounded-lg border focus:outline-none text-xs"
                id="parent_Id"
                onChange={handleChange}
                value={FormData.parent_Id}
              >
                <option value="">Select Parent</option>
                {CategoryData.map((item, index) => (
                  <option key={index} value={item.id}>
                    {item.category_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex justify-end items-center pt-4 gap-x-4">
              <CancelButton onClick={handleCancel} size="sm" text="Cancel" />
              <AddButton
                onClick={handleSubmit}
                size="sm"
                text={FormData.id ? "Edit Category" : "Add Category"}
              />
            </div>
          </div>
        </div>

        <div className="flex-1 border drop-shadow p-3 bg-white rounded-lg">
          <div className="p-4 w-full overflow-x-auto">
            <table className="min-w-full border border-gray-200 bg-white rounded-lg overflow-hidden">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                    ID
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                    Category Name
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                    Parent Category
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                    Status
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                    Action
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-200">
                {CategoryData.length > 0 ? (
                  <>
                    {CategoryData.map((item, index) => {
                      const parentCategoryName =
                        CategoryData.filter((i) => i.id === item.parent_Id)[0]
                          ?.category_name || "none";
                      return (
                        <tr key={index} className="hover:bg-gray-50">
                          <td className="px-4 py-3 text-sm text-gray-700">
                            {index + 1}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700">
                            {item.category_name}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700">
                            {parentCategoryName}
                          </td>
                          <td className="px-4 py-3 text-sm">
                            <span
                              className={`px-2 py-1 ${
                                item.status === 1
                                  ? "bg-green-100 text-green-700"
                                  : "bg-red-100 text-red-700"
                              } rounded text-xs`}
                            >
                              {item.status === 1 ? "active" : "inactive"}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-sm flex gap-2">
                            <EditButton
                              onClick={() => handleEdit(item)}
                              text="Edit"
                            />
                            <DeleteButton
                              onClick={() => handleDelete(item)}
                              text="Delete"
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </>
                ) : (
                  <TableLoader colSpan={5} />
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogCategories;
